import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/frenteIdemia.svg'
import _imports_1 from '@/assets/images/versoIdemia.svg'
import _imports_2 from '@/assets/images/frenteOT.svg'
import _imports_3 from '@/assets/images/versoOT.svg'
import _imports_4 from '@/assets/images/frenteGemalto.svg'
import _imports_5 from '@/assets/images/versoGemalto.svg'
import _imports_6 from '@/assets/images/frenteMorpho.svg'
import _imports_7 from '@/assets/images/versoMorpho.svg'
import _imports_8 from '../../assets/images/download.gif'


const _hoisted_1 = {
  class: "modal modal-lg fade",
  id: "modal-smartcard",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = {
  key: 0,
  class: "nav nav--wizard my-4 d-flex flex-row justify-content-center"
}
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = {
  key: 1,
  class: "smartcard-choice"
}
const _hoisted_8 = { class: "form-smartcard d-flex flex-row justify-content-center" }
const _hoisted_9 = { class: "form-check" }
const _hoisted_10 = { class: "form-check ms-3" }
const _hoisted_11 = { class: "form-check ms-3" }
const _hoisted_12 = { class: "smarcard-choice-radio" }
const _hoisted_13 = { class: "awp-choice" }
const _hoisted_14 = { class: "images-idemia-card d-flex flex-row justify-content-center" }
const _hoisted_15 = { class: "images-idemia-card__backside d-flex flex-column" }
const _hoisted_16 = { class: "images-ot-card d-flex flex-row justify-content-center" }
const _hoisted_17 = { class: "images-ot-card__backside d-flex flex-column" }
const _hoisted_18 = { class: "gemalto-choice" }
const _hoisted_19 = { class: "images-gemalto-card d-flex flex-row justify-content-center mt-4" }
const _hoisted_20 = { class: "images-gemalto-card__backside d-flex flex-column" }
const _hoisted_21 = { class: "morpho-choice" }
const _hoisted_22 = { class: "images-morpho-card d-flex flex-row justify-content-center mt-4" }
const _hoisted_23 = { class: "images-gemalto-card__backside d-flex flex-column" }
const _hoisted_24 = {
  key: 2,
  class: "os-choice"
}
const _hoisted_25 = { class: "os-choice__images d-flex flex-row justify-content-center align-items-center my-5" }
const _hoisted_26 = ["src"]
const _hoisted_27 = ["src"]
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "driver-choice d-flex flex-column" }
const _hoisted_30 = {
  key: 0,
  class: "text-start"
}
const _hoisted_31 = {
  key: 3,
  class: "final-modal-smartcard d-flex flex-column justify-content-center"
}
const _hoisted_32 = { class: "text-start d-flex flex-row" }
const _hoisted_33 = { class: "text-start d-flex flex-row" }
const _hoisted_34 = { class: "text-start d-flex flex-row" }
const _hoisted_35 = { class: "text-start d-flex flex-row" }
const _hoisted_36 = ["href"]
const _hoisted_37 = { class: "modal-footer" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = {
  key: 0,
  class: "col-5 text-danger text-start"
}
const _hoisted_40 = ["href", "disabled"]
const _hoisted_41 = {
  key: 3,
  class: "me-3 link btn btn-outline-primary",
  type: "button",
  href: "/ManualEmissaoA3.pdf",
  target: "_blank"
}
const _hoisted_42 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Selectable = _resolveComponent("Selectable")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[46] || (_cache[46] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("button", {
              class: "btn-close",
              type: "button",
              "data-bs-dismiss": "modal",
              "aria-label": "Fechar"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("h4", null, "Vamos te ajudar a fazer o download do Driver referente ao seu Smartcard!", 512), [
              [_vShow, _ctx.stepModal === 1 || _ctx.stepModal === 2]
            ]),
            _withDirectives(_createElementVNode("h4", null, "Aguarde enquanto o download é concluído", 512), [
              [_vShow, _ctx.stepModal === 3]
            ]),
            (_ctx.stepModal !== 3)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                  _createElementVNode("li", {
                    class: _normalizeClass(["nav-item", [_ctx.stepModal === 2 ? "nav--wizard__nav-item--success" : ""]])
                  }, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["nav-link", [_ctx.stepModal === 1 ? "active" : "", _ctx.stepModal === 2 ? "disabled" : ""]]),
                      content: "1"
                    }, "Selecione o modelo do Chip", 2)
                  ], 2),
                  _createElementVNode("li", _hoisted_6, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["nav-link", [_ctx.stepModal === 2 ? "active" : ""]]),
                      content: "2"
                    }, "Selecione o Sistema Operacional", 2)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.stepModal === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[32] || (_cache[32] = _createElementVNode("p", null, "Em qual Smartcard está armazenado seu Certificado Digital?", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input form-check-input--success",
                        id: "radioAWP",
                        type: "radio",
                        name: "radioSmartcard",
                        value: "AWP",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.smartcardChoice) = $event)),
                        checked: ""
                      }, null, 512), [
                        [_vModelRadio, _ctx.smartcardChoice]
                      ]),
                      _cache[15] || (_cache[15] = _createElementVNode("label", {
                        class: "form-check-label",
                        for: "radioAWP"
                      }, "AWP", -1))
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input form-check-input--success",
                        id: "radioGEMALTO",
                        type: "radio",
                        name: "radioSmartcard",
                        value: "GEMALTO",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.smartcardChoice) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.smartcardChoice]
                      ]),
                      _cache[16] || (_cache[16] = _createElementVNode("label", {
                        class: "form-check-label",
                        for: "radioGEMALTO"
                      }, "GEMALTO", -1))
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input form-check-input--success",
                        id: "radioMORPHO",
                        type: "radio",
                        name: "radioSmartcard",
                        value: "MORPHO",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.smartcardChoice) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.smartcardChoice]
                      ]),
                      _cache[17] || (_cache[17] = _createElementVNode("label", {
                        class: "form-check-label",
                        for: "radioMORPHO"
                      }, "MORPHO", -1))
                    ])
                  ]),
                  _cache[33] || (_cache[33] = _createElementVNode("p", { class: "mt-2" }, [
                    _createTextVNode("Compare o "),
                    _createElementVNode("strong", null, "Chip e o verso"),
                    _createTextVNode(" do seu smart card para selecionar o driver correto")
                  ], -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("div", _hoisted_13, [
                      _cache[24] || (_cache[24] = _createElementVNode("p", null, "IDEMIA", -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "images-idemia-card__frontside d-flex flex-column" }, [
                          _createElementVNode("span", { class: "text-start ms-3" }, "Frente"),
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "Imagem de um card IDEMIA"
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_15, [
                          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-start ms-3" }, "Verso", -1)),
                          _cache[19] || (_cache[19] = _createElementVNode("img", {
                            src: _imports_1,
                            alt: "Imagem de um card IDEMIA"
                          }, null, -1)),
                          _createElementVNode("span", {
                            id: "tooltip-idemia",
                            "data-bs-toggle": "tooltip",
                            "data-bs-placement": "bottom",
                            "data-bs-custom-class": "custom-tooltip",
                            "data-bs-title": "IDEMIA 2 - 9999999X9 - 99/99",
                            onMouseover: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createTooltip("#tooltip-idemia")))
                          }, "AAAAAAA", 32)
                        ])
                      ]),
                      _cache[25] || (_cache[25] = _createElementVNode("p", { class: "mt-2" }, "OT", -1)),
                      _createElementVNode("div", _hoisted_16, [
                        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "images-ot-card__frontside d-flex flex-column" }, [
                          _createElementVNode("span", { class: "text-start ms-3" }, "Frente"),
                          _createElementVNode("img", {
                            src: _imports_2,
                            alt: "Imagem de um card IDEMIA"
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_17, [
                          _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-start ms-3" }, "Verso", -1)),
                          _cache[22] || (_cache[22] = _createElementVNode("img", {
                            src: _imports_3,
                            alt: "Imagem de um card IDEMIA"
                          }, null, -1)),
                          _createElementVNode("span", {
                            id: "tooltip-ot",
                            "data-bs-toggle": "tooltip",
                            "data-bs-placement": "right",
                            "data-bs-custom-class": "custom-tooltip",
                            "data-bs-title": "OT. 99999XX999999999 - 99/99",
                            onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createTooltip("#tooltip-ot")))
                          }, "AAAAAAA", 32)
                        ])
                      ])
                    ], 512), [
                      [_vShow, _ctx.smartcardChoice === 'AWP']
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "images-gemalto-card__frontside d-flex flex-column" }, [
                          _createElementVNode("span", { class: "text-start ms-3" }, "Frente"),
                          _createElementVNode("img", {
                            src: _imports_4,
                            alt: "Imagem de um card GEMALTO"
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_20, [
                          _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-start ms-3" }, "Verso", -1)),
                          _cache[27] || (_cache[27] = _createElementVNode("img", {
                            src: _imports_5,
                            alt: "Imagem de um card GEMALTO"
                          }, null, -1)),
                          _createElementVNode("span", {
                            id: "tooltip-gemalto",
                            "data-bs-toggle": "tooltip",
                            "data-bs-placement": "left",
                            "data-bs-custom-class": "custom-tooltip",
                            "data-bs-title": "gemalto xxxX9999999X9999",
                            onMouseover: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createTooltip("#tooltip-gemalto")))
                          }, "AAAAAAA", 32)
                        ])
                      ])
                    ], 512), [
                      [_vShow, _ctx.smartcardChoice === 'GEMALTO']
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "images-morpho-card__frontside d-flex flex-column" }, [
                          _createElementVNode("span", { class: "text-start ms-3" }, "Frente"),
                          _createElementVNode("img", {
                            src: _imports_6,
                            alt: "Imagem de um card MORPHO"
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_23, [
                          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-start ms-3" }, "Verso", -1)),
                          _cache[30] || (_cache[30] = _createElementVNode("img", {
                            src: _imports_7,
                            alt: "Imagem de um card MORPHO"
                          }, null, -1)),
                          _createElementVNode("span", {
                            id: "tooltip-morpho",
                            "data-bs-toggle": "tooltip",
                            "data-bs-placement": "right",
                            "data-bs-custom-class": "custom-tooltip",
                            "data-bs-title": "Morpho 99/99",
                            onMouseover: _cache[6] || (_cache[6] = ($event: any) => (_ctx.createTooltip("#tooltip-morpho")))
                          }, "AAAAA", 32)
                        ])
                      ])
                    ], 512), [
                      [_vShow, _ctx.smartcardChoice === 'MORPHO']
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.stepModal === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _cache[34] || (_cache[34] = _createElementVNode("p", null, "Escolha abaixo o Sistema Operacional do seu computador", -1)),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("a", {
                      type: "button",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.operationalSystem = "windowsOSSelected")),
                      "data-bs-toggle": "tooltip",
                      "data-bs-placement": "bottom",
                      "data-bs-title": "windows"
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.windowsChecked,
                        alt: "Logo do Windows"
                      }, null, 8, _hoisted_26)
                    ]),
                    _createElementVNode("a", {
                      class: "mx-5",
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.operationalSystem = "macOSSelected"))
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.macChecked,
                        alt: "Logo do MacOS"
                      }, null, 8, _hoisted_27)
                    ]),
                    _createElementVNode("a", {
                      type: "button",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.operationalSystem = "linuxOSSelected"))
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.linuxChecked,
                        alt: "Logo do Linux"
                      }, null, 8, _hoisted_28)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    (_ctx.drivers.length > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_30, "Agora selecione a Versão"))
                      : _createCommentVNode("", true),
                    _withDirectives((_openBlock(), _createBlock(_component_Selectable, {
                      options: _ctx.drivers,
                      label: "",
                      name: "index",
                      icon: "download",
                      labelSelectable: "nome",
                      placeholder: "Selecione o driver desejado",
                      modelValue: _ctx.driverChoice,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.driverChoice) = $event)),
                      key: _ctx.selectableCount
                    }, null, 8, ["options", "modelValue"])), [
                      [_vShow, _ctx.drivers.length > 0]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.stepModal === 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _cache[40] || (_cache[40] = _createElementVNode("div", { class: "d-flex flex-row justify-content-center" }, [
                    _createElementVNode("img", {
                      class: "my-3",
                      src: _imports_8,
                      alt: "Gif animado de download"
                    })
                  ], -1)),
                  _cache[41] || (_cache[41] = _createElementVNode("p", { class: "text-start my-3" }, [
                    _createElementVNode("strong", null, "Importante")
                  ], -1)),
                  _createElementVNode("p", _hoisted_32, [
                    _createVNode(_component_Icon, {
                      class: "icon-check",
                      name: "circle-check"
                    }),
                    _cache[35] || (_cache[35] = _createElementVNode("span", null, [
                      _createTextVNode("Enquanto isso, certifique-se de que sua mídia esteja "),
                      _createElementVNode("strong", null, "desconectada"),
                      _createTextVNode(" do seu computador para prosseguir com a instalação.")
                    ], -1))
                  ]),
                  _createElementVNode("p", _hoisted_33, [
                    _createVNode(_component_Icon, {
                      class: "icon-check",
                      name: "circle-check"
                    }),
                    _cache[36] || (_cache[36] = _createElementVNode("span", null, "Após a conclusão do Download, execute o arquivo instalado e avance as etapas até concluir a instalação do programa.", -1))
                  ]),
                  _createElementVNode("p", _hoisted_34, [
                    _createVNode(_component_Icon, {
                      class: "icon-check",
                      name: "circle-check"
                    }),
                    _cache[37] || (_cache[37] = _createElementVNode("span", null, [
                      _createTextVNode("Após a instalação do programa, "),
                      _createElementVNode("strong", null, "insira a mídia na leitora.")
                    ], -1))
                  ]),
                  _createElementVNode("p", _hoisted_35, [
                    _createVNode(_component_Icon, {
                      class: "icon-check",
                      name: "circle-check"
                    }),
                    _createElementVNode("span", null, [
                      _cache[38] || (_cache[38] = _createTextVNode("Em seguida, ")),
                      _createElementVNode("a", { href: _ctx.getLinkEmissor }, "faça o download do emissor", 8, _hoisted_36),
                      _cache[39] || (_cache[39] = _createTextVNode(" e siga os passos até a conclusão da instalação e a gravação dos dados do Certificado Digital em sua mídia."))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              (_ctx.hasDriversAndNoHasOS)
                ? (_openBlock(), _createElementBlock("p", _hoisted_39, "Não há driver encontrado para este Sistema Operacional"))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["text-end", _ctx.hasDriversAndNoHasOS ? "col-7" : "col-12"])
              }, [
                (_ctx.stepModal === 2)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "me-3 btn btn-outline-primary",
                      type: "button",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.stepModal--))
                    }, "Voltar"))
                  : _createCommentVNode("", true),
                (_ctx.stepModal === 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-primary",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.stepModal++)),
                      type: "button"
                    }, [
                      _cache[42] || (_cache[42] = _createElementVNode("span", null, "Avançar", -1)),
                      _createVNode(_component_Icon, {
                        class: "ms-2",
                        name: "arrow-right"
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.stepModal === 2)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: _normalizeClass(["btn btn-primary", !_ctx.hasDriversAndStepTwo && _ctx.driverChoice === "" ? "btn-secondary" : "btn-primary"]),
                      href: _ctx.link,
                      disabled: !_ctx.hasDriversAndStepTwo,
                      type: "button",
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.downloadDriver && _ctx.downloadDriver(...args)))
                    }, [
                      _cache[43] || (_cache[43] = _createElementVNode("span", null, "Fazer download do drive", -1)),
                      _createVNode(_component_Icon, {
                        class: "ms-2",
                        name: "download"
                      })
                    ], 10, _hoisted_40))
                  : _createCommentVNode("", true),
                (_ctx.stepModal === 3)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_41, [
                      _createVNode(_component_Icon, {
                        class: "me-2",
                        name: "up-right-from-square"
                      }),
                      _cache[44] || (_cache[44] = _createElementVNode("span", null, "Abrir guia de instalação", -1))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.stepModal === 3)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 4,
                      class: "btn btn-primary",
                      type: "button",
                      href: _ctx.getLinkEmissor,
                      target: "_blank"
                    }, [
                      _cache[45] || (_cache[45] = _createElementVNode("span", null, "Baixar emissor", -1)),
                      _createVNode(_component_Icon, {
                        class: "ms-2",
                        name: "download"
                      })
                    ], 8, _hoisted_42))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("button", {
      class: "btn-desktop btn btn-primary mt-3",
      type: "button",
      "data-bs-target": "#modal-smartcard",
      "data-bs-toggle": "modal",
      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.stepModal = 1))
    }, [
      _createVNode(_component_Icon, {
        class: "me-2",
        name: "download"
      }),
      _cache[47] || (_cache[47] = _createElementVNode("span", null, "Baixar driver", -1))
    ])
  ], 64))
}